import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { ISaveJobPostDetailPayload } from '../types';

export const saveJobPostDetail = async (
  id: string,
  data: Partial<ISaveJobPostDetailPayload>,
): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.patch(`/posting-service/postings/${id}`, data, { headers });
};
